<template>
  <keep-alive>
    <div class="editor_warp">
      <div ref="editor" :style="editorStyle" class="editor"></div>
      <div class="lookMore">
        <div @click="lookMore()">{{ showMoreBtn ? "显示全部" : "收起" }}</div>
      </div>
      <el-upload class="avatar-uploader" :action="uploadAPI" name="file" :show-file-list="false"
        :on-success="uploadSuccess" v-show="false">
        <el-button size="small" type="primary" @click="uploadBtn" class="my-upload">点击上传</el-button>
      </el-upload>
    </div>
  </keep-alive>
</template>

<script>
import Quill from "quill";
import "quill/dist/quill.snow.css";
import { ImageDrop } from "quill-image-drop-module";
import ImageResize from "quill-image-resize-module";
import { postUploadImg } from "@/server/tops/devOps";
Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageResize", ImageResize);
let Link = Quill.import("formats/link");
class FileBlot extends Link {
  // 继承Link Blot
  static create(value) {
    let node = undefined;
    if (value && !value.href) {
      // 适应原本的Link Blot
      node = super.create(value);
    } else {
      // 自定义Link Blot
      node = super.create(value.href);
      // node.setAttribute('download', value.innerText);  // 左键点击即下载
      node.innerText = value.innerText;
      node.download = value.innerText;
    }
    return node;
  }
}
FileBlot.blotName = "link";
FileBlot.tagName = "A";
Quill.register(FileBlot);
const titleConfig = {
  "ql-bold": "加粗",
  "ql-color": "颜色",
  "ql-font": "字体",
  "ql-code": "插入代码",
  "ql-italic": "斜体",
  "ql-link": "添加链接",
  "ql-background": "颜色",
  "ql-size": "字体大小",
  "ql-strike": "删除线",
  "ql-script": "上标/下标",
  "ql-underline": "下划线",
  "ql-blockquote": "引用",
  "ql-header": "标题",
  "ql-indent": "缩进",
  "ql-list": "列表",
  "ql-align": "文本对齐",
  "ql-direction": "文本方向",
  "ql-code-block": "代码块",
  "ql-formula": "公式",
  "ql-image": "图片",
  "ql-video": "视频",
  "ql-clean": "清除字体样式",
  "ql-upload": "文件",
  "ql-table": "插入表格",
  "ql-table-insert-row": "插入行",
  "ql-table-insert-column": "插入列",
  "ql-table-delete-row": "删除行",
  "ql-table-delete-column": "删除列",
};
var fonts = [
  "monospace",
  "FangSong",
  "Microsoft-YaHei",
  "SimSun",
  "serif",
  "SimHei",
  "KaiTi",
  "Arial",
  "sans-serif",
];
var Font = Quill.import("formats/font");
Font.whitelist = fonts; //将字体加入到白名单
Quill.register(Font, true);
const FontAttributor = Quill.import("attributors/class/size");
FontAttributor.whitelist = ["ft10", "ft12", "ft14", "ft16", "ft18", "ft32"];
Quill.register(FontAttributor, true);
export default {
  name: "Editor",
  props: {
    content: {
      type: String,
      default: () => {
        return "";
      },
    },
    placeholder: {
      type: String,
      default: () => {
        return "";
      },
    },
    edithHeight: {
      type: String,
      default: () => {
        return "100px";
      },
    },
    disabled: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    readOnly: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    dialogVisibleModelType: {
      type: String,
      default: () => {
        return "create";
      },
    },
  },
  data() {
    return {
      fileReader: null,
      fileList: [],
      quill: null,
      uploadAPI: "https://devops-test.ehsy.com/devops/common/upload",
      msg: "",
      options: {
        theme: "snow",
        placeholder: "",
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"],
              [{ header: 1 }, { header: 2 }],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ indent: "-1" }, { indent: "+1" }],
              [{ color: [] }, { background: [] }],
              [
                { table: "TD" },
                { "table-insert-row": "TIR" },
                { "table-insert-column": "TIC" },
                { "table-delete-row": "TDR" },
                { "table-delete-column": "TDC" },
              ],
              ["link", "sourceEditor"],
              ["clean"],
            ],
            handlers: {
              table: function (val) {
                this.quill.getModule("table").insertTable(2, 3);
              },
              "table-insert-row": function () {
                this.quill.getModule("table").insertRowBelow();
              },
              "table-insert-column": function () {
                this.quill.getModule("table").insertColumnRight();
              },
              "table-delete-row": function () {
                this.quill.getModule("table").deleteRow();
              },
              "table-delete-column": function () {
                this.quill.getModule("table").deleteColumn();
              },
              sourceEditor: function () {
                // 添加工具方法
                document.getElementsByClassName("my-upload")[0].click();
              },
            },
          },
          table: true,
          imageDrop: true, //图片拖拽
          imageResize: {
            displayStyles: {
              // 放大缩小
              backgroundColor: "black",
              border: "none",
              color: "white",
            },
            modules: ["Resize", "DisplaySize", "Toolbar"],
          },
        },
      },
      editorStyle: {
        height: "100%",
        borderBottom: "none"
      },
      showMoreBtn: true,
    };
  },
  methods: {
    uploadSuccess(res, file) {
      if (res.code === 0 && this.disabled) {
        // 获取光标所在位置
        const length = this.quill.getSelection(true);
        let type = file.raw.type;
        if (type.includes("image")) {
          // 插入图片  res.url为服务器返回的图片地址
          this.quill.insertEmbed(length.index, "image", res.url);
        } else {
          this.quill.insertEmbed(length.index, "link", {
            href: res.url,
            innerText: file.name || "链接",
          });
        }
        // 调整光标到最后
        this.quill.setSelection(length.index + 1);
      } else {
        this.$message.error("图片插入失败");
      }
    },
    uploadBtn() { },
    addQuillTitle() {
      const oToolBar = document.querySelector(".ql-toolbar");
      const aButton = oToolBar.querySelectorAll("button");
      const aSelect = oToolBar.querySelectorAll("select");
      aButton.forEach(function (item) {
        if (item.className === "ql-script") {
          item.value === "sub" ? (item.title = "下标") : (item.title = "上标");
        } else if (item.className === "ql-indent") {
          item.value === "+1"
            ? (item.title = "向右缩进")
            : (item.title = "向左缩进");
        } else {
          item.title = titleConfig[item.classList[0]];
        }
      });
      aSelect.forEach(function (item) {
        item.parentNode.title = titleConfig[item.classList[0]];
      });
    },
    lookMore() {
      if(!this.edithHeight) this.edithHeight = '100px';
      /*this.editorStyle = {
        height: this.showMoreBtn ? "100%" : this.edithHeight,
        borderBottom: "none"
      };*/
      this.editorStyle = {
        height: '100%',
        borderBottom: "none",
      };
      if(!this.showMoreBtn){
        this.editorStyle.maxHeight = '46vh';
        this.editorStyle.overflowY = 'scroll';
      }
      this.showMoreBtn = !this.showMoreBtn;
    },
  },
  created() {
    if (this.dialogVisibleModelType === "update") {
      if(!this.edithHeight) this.edithHeight = '100px';
      /*this.editorStyle = {
        height: this.edithHeight,
        borderBottom: "none"
      };*/
      this.editorStyle = {
        height:'100%',
        maxHeight:'46vh',
        borderBottom: "none",
        overflowY: 'scroll',
      };
      this.showMoreBtn = true;
    }
  },
  mounted() {
    this.fileReader = new FileReader();
    const dom = this.$el.querySelector(".editor");
    this.quill = new Quill(dom, this.options);
    this.myEl = this.$el.querySelector(".ql-sourceEditor");
    this.quill.root.innerHTML = this.content;
    this.quill.root.dataset.placeholder = this.placeholder;
    this.quill.enable(this.disabled);
    this.quill.on("text-change", async (delta, oldDelta, source) => {
      if (delta?.ops[0]?.insert?.image || delta?.ops[1]?.insert?.image) {
        const dataurl =
          delta?.ops[0]?.insert?.image || delta?.ops[1]?.insert?.image;
        if (dataurl.startsWith("data:")) {
          const ret = await postUploadImg({ img: dataurl });
          if (ret?.data?.url) {
            this.quill.root.innerHTML = this.quill.root.innerHTML.replace(
              dataurl,
              ret?.data?.url
            );
          }
        }
      }
      if (this.quill.root.innerHTML === "<p><br></p>") {
        this.quill.root.innerHTML = "";
      }
      this.$nextTick(() => {
        this.quill.setSelection(this.quill?.getSelection()?.index || this.quill.root.innerHTML.length);
      });
      this.$emit("contentData", this.quill.root.innerHTML);
    });
    this.$el.querySelector(
      ".ql-table-insert-row"
    ).innerHTML = `<svg t="1591862376726" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6306" width="18" height="200"><path d="M500.8 604.779L267.307 371.392l-45.227 45.27 278.741 278.613L779.307 416.66l-45.248-45.248z" p-id="6307"></path></svg>`;
    this.$el.querySelector(
      ".ql-table-insert-column"
    ).innerHTML = `<svg t="1591862238963" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6509" width="18" height="200"><path d="M593.450667 512.128L360.064 278.613333l45.290667-45.226666 278.613333 278.762666L405.333333 790.613333l-45.226666-45.269333z" p-id="6510"></path></svg>`;
    this.$el.querySelector(
      ".ql-table-delete-row"
    ).innerHTML = `<svg t="1591862253524" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6632" width="18" height="200"><path d="M500.8 461.909333L267.306667 695.296l-45.226667-45.269333 278.741333-278.613334L779.306667 650.026667l-45.248 45.226666z" p-id="6633"></path></svg>`;
    this.$el.querySelector(
      ".ql-table-delete-column"
    ).innerHTML = `<svg t="1591862261059" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6755" width="18" height="200"><path d="M641.28 278.613333l-45.226667-45.226666-278.634666 278.762666 278.613333 278.485334 45.248-45.269334-233.365333-233.237333z" p-id="6756"></path></svg>`;
    this.addQuillTitle();
    this.$el.querySelector(
      ".ql-sourceEditor"
    ).innerHTML = `<svg t="1592278063482" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6358" width="18" height="200"><path d="M704 341.333333h64a64 64 0 0 1 64 64v362.666667a64 64 0 0 1-64 64H256a64 64 0 0 1-64-64V405.333333a64 64 0 0 1 64-64h64v64h-64v362.666667h512V405.333333h-64v-64zM517.653333 124.629333l150.826667 150.826667-45.226667 45.269333-74.026666-74.005333v304.768h-64V247.616l-73.173334 73.130667-45.248-45.248 150.826667-150.848z" p-id="6359"></path></svg>`;
  },
  watch: {
    disabled: {
      deep: true, //true为进行深度监听,false为不进行深度监听
      handler(newVal) {
        if (newVal) {
          this.editorStyle = {
            height: '100%'
          }
        }
        this.quill.enable(newVal);
      },
    },
  },
};
</script>
<style lang="scss">
.editor_warp {
  .lookMore {
    position: relative;
    text-align: center;
    background: linear-gradient(to bottom,
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 0) 0px,
        #fefefe 30px);
    // background:linear-gradient(to bottom,red,yellow 0px,green 32px);
    border: 1px solid #ccc;
    border-top: none;
    margin-top: -28px;
    font-weight: bold;
    color: gray;
    cursor: pointer;
  }

  .lookMore:hover {
    color: #409eff;
    cursor: pointer;
  }

  .editor {
    margin-bottom: 28px;

    .ql-editor {
      min-height: 100px;
      padding-bottom: 30px;
      font-size: 14px;
    }

    .el-upload-list__item {
      transition: none !important;
    }

    .ql-snow .ql-picker-label::before {
      position: absolute;
      top: 0;
    }

    .ql-icon-picker .ql-picker-label svg {
      position: absolute;
      top: 0;
    }

    .ql-snow .ql-icon-picker .ql-picker-label svg {
      position: absolute;
      top: 0;
    }

    .ql-snow .ql-color-picker .ql-picker-label svg {
      position: absolute;
      top: 0;
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="ft10"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="ft10"]::before {
      content: "10px";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="ft12"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="ft12"]::before {
      content: "12px";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="ft14"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="ft14"]::before {
      content: "14px";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="ft16"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="ft16"]::before {
      content: "16px";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="ft18"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="ft18"]::before {
      content: "18px";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="ft32"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="ft32"]::before {
      content: "32px";
    }

    .ql-size-ft10 {
      font-size: 10px;
    }

    .ql-size-ft12 {
      font-size: 10px;
    }

    .ql-size-ft14 {
      font-size: 14px;
    }

    .ql-size-ft16 {
      font-size: 16px;
    }

    .ql-size-ft18 {
      font-size: 18px;
    }

    .ql-size-ft32 {
      font-size: 32px;
    }

    /* 字体样式 */
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="SimSun"]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="SimSun"]::before {
      content: "宋体";
      font-family: "SimSun";
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="SimHei"]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="SimHei"]::before {
      content: "黑体";
      font-family: "SimHei";
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Microsoft-YaHei"]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Microsoft-YaHei"]::before {
      content: "微软雅黑";
      font-family: "Microsoft YaHei";
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="KaiTi"]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="KaiTi"]::before {
      content: "楷体";
      font-family: "KaiTi";
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="FangSong"]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="FangSong"]::before {
      content: "仿宋";
      font-family: "FangSong";
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Arial"]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Arial"]::before {
      content: "Arial";
      font-family: "Arial";
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Times-New-Roman"]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Times-New-Roman"]::before {
      content: "Times New Roman";
      font-family: "Times New Roman";
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="sans-serif"]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="sans-serif"]::before {
      content: "sans-serif";
      font-family: "sans-serif";
    }

    .ql-font-SimHei {
      font-family: "SimHei";
    }

    .ql-font-SimSun {
      font-family: "SimSun";
    }

    .ql-font-Microsoft-YaHei {
      font-family: "Microsoft YaHei";
    }

    .ql-font-KaiTi {
      font-family: "KaiTi";
    }

    .ql-font-FangSong {
      font-family: "FangSong";
    }

    .ql-font-Arial {
      font-family: "Arial";
    }

    .ql-font-Times-New-Roman {
      font-family: "Times New Roman";
    }

    .ql-font-sans-serif {
      font-family: "sans-serif";
    }
  }

  .ql-editor {
    scrollbar-width: thin;
    scrollbar-color: skyblue #eee;
  }

  .ql-editor::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 16px;
  }

  .ql-editor::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background-color: skyblue;
    background-image: -webkit-linear-gradient(45deg,
        rgba(255, 255, 255, 0.2) 25%,
        transparent 25%,
        transparent 50%,
        rgba(255, 255, 255, 0.2) 50%,
        rgba(255, 255, 255, 0.2) 75%,
        transparent 75%,
        transparent);
  }

  .ql-editor::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ededed;
    border-radius: 10px;
  }
}
</style>
